import React from "react";
import PropTypes from "prop-types";
import "../../css/TrackBoxCounter.less";

const TrackBoxCounter = (props) => (
  <div className="track-box-counter align-right">
    <div>
      Total Tracks <span>{props.count || 0}</span>
    </div>
  </div>
);

TrackBoxCounter.propTypes = {
  // count: PropTypes.isRequired,
};

TrackBoxCounter.defaultProps = {
  // bla: 'test',
};

export default TrackBoxCounter;
